// 95% copied from https://github.com/rhysd/remark-emoji

import visit from 'unist-util-visit'
import emoticon from 'emoticon'

import { MARKDOWN_IGNORE_IDENTIFIER } from './blockElements'
import { LiteralVisitNode, VisitNode } from './types'

// contains short emoji at the end of the text
const RE_SHORT_EMOJI_AT_THE_END = /[$@|*'",;.=:\-)([\]\\/<>038BOopPsSdDxXzZ]{2,5}$/g
// contains short emoji at the middle of the text and ends with whitespace, "?" or "!"
const RE_SHORT_EMOJI_AT_THE_MIDDLE = /[$@|*'",;.=:\-)([\]\\/<>038BOopPsSdDxXzZ]{2,5}[\s/?/!]/g
// contains short emoji at the middle of the text and ends with dot
const RE_SHORT_EMOJI_AT_THE_MIDDLE_DOT = /[$@|*'",;.=:\-)([\]\\/<>038BOopPsSdDxXzZ]{2,5}[/.]/g

const DEFAULT_SETTINGS = {
    padSpaceAfter: false,
}

export const emoji = (options: Partial<typeof DEFAULT_SETTINGS> = {}) => {
    const settings = { ...DEFAULT_SETTINGS, ...options }
    const pad = !!settings.padSpaceAfter

    function getEmojiByShortCode(match: string, allowPartialMatch: boolean) {
        // find emoji by shortcode - full match or with-out last char as it could be from text e.g. :-),
        const iconFull = emoticon.find((e) => e.emoticons.includes(match)) // full match
        const iconPart = allowPartialMatch && emoticon.find((e) => e.emoticons.includes(match.slice(0, -1))) // second search pattern

        if (!iconFull && !iconPart) {
            return match
        }

        const trimmedChar = iconPart ? match.slice(-1) : ''
        const addPad = pad ? ' ' : ''
        const icon = iconFull ? iconFull.emoji + addPad : iconPart && iconPart.emoji + addPad + trimmedChar
        return icon || match
    }

    function transformer(tree: VisitNode) {
        visit(tree, 'text', (node: LiteralVisitNode) => {
            if (!node.value.startsWith(MARKDOWN_IGNORE_IDENTIFIER)) {
                node.value = node.value.replace(RE_SHORT_EMOJI_AT_THE_END, (match) => getEmojiByShortCode(match, false))
                node.value = node.value.replace(RE_SHORT_EMOJI_AT_THE_MIDDLE, (match) =>
                    getEmojiByShortCode(match, true)
                )
                node.value = node.value.replace(RE_SHORT_EMOJI_AT_THE_MIDDLE_DOT, (match) =>
                    getEmojiByShortCode(match, true)
                )
            }
        })
    }

    return transformer
}
